import { Box, styled } from "@mui/material";

export const SectionCard = styled(Box)(({ theme }) => ({
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    boxShadow: '0px 4px 80px 0px rgba(112,144,176,0.14)',
    height: '100%',
}));
